import {Expose, Type} from "class-transformer";
import Booth from "./Booth";
import Meta from "./Meta";
import Model from "./Model";
import Attachment from "./Attachment";
import {Map} from "immutable";
import {strict_join} from "../../_helpers/utils";
import Address from "./Address";

interface ShopBoothCollection {
    boothIds: Map<number, number>,
    meta: Meta
}

interface ShopProfessionalCollection {
    ids: Map<number, number>,
    meta: Meta
}


export default class Shop extends Address implements Imageable {
    name: string;
    businessType: string;
    license: string;
    phone: string;

    @Expose({name: "primary_picture_url"})
    primaryPictureUrl: string;

    @Expose({name: "is_liked"})
    isFollowed: boolean;

    @Type(() => Attachment)
    images: Attachment[];

    toString(): string {
        return this.name;
    };

    @Expose({name: "like_count"})
    likeCount: number;

    boothCollection: ShopBoothCollection;
    professionalCollection: ShopProfessionalCollection;

    @Expose({name: "user_id"})
    userId: number;

    @Expose({name: "address_1"})
    street1: string;
    @Expose({name: "address_2"})
    street2: string;

    address(): string {
        let parts: string[] = [this.street1, this.street2, this.city, this.state]
            .filter((each) => {
                return each && each.trim().length > 0
            });

        return strict_join(parts, ', ') + ' ' + this.zip
    }

    isOwnedBy(userId: number): boolean {
        return this.userId == userId;
    }

    imageUrl(): string {
        return this.primaryPictureUrl || window.Styleteq.images.userDefault;
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Shop.ts